import { enTranslation } from './en.translation';

export const translationConfig = {
  en: enTranslation,
};

export const languages = () => Object.keys(translationConfig);
